import { useSetting } from '../../../util/useSetting';
import { useEffect, useState } from 'react';
import { teacherFetchStudentAnswers } from '../../../services2/studentAnswers.service';
import { connect } from 'react-redux';
import RenderAQuestion from './RenderAQuestion';
function InteractiveAreaAnswer(props) {
    const { fontSize } = useSetting();

    const [showMore, setShowMore] = useState(false);
    const handleShowMore = () => {
        setShowMore(!showMore);
    }
    const [answers, setAnswers] = useState([]);

    async function fetchAnswer() {
        if (props.type === '核心問題') {
            let result = await teacherFetchStudentAnswers(props.token.token, {
                questionId: `core_${props.index}`,
                status: 'active',
                session: props.index === 0 ? '互文閱讀一' : '互文閱讀二',
                schoolMissionId: props.schoolMissionId
            }, {});
            setAnswers(result?.result);
        } else if (props.type === '短答題') {
            let result = await teacherFetchStudentAnswers(props.token.token, {
                questionId: `practice_${props.index}_${props.data?.id}`,
                status: 'active',
                session: props.index === 0 ? '互文閱讀一' : '互文閱讀二',
                schoolMissionId: props.schoolMissionId
            }, {});
            setAnswers(result?.result);
        }
    }
    useEffect(() => {
        fetchAnswer();
    }, [props.data, props.index, props.schoolMissionId]);

    if (props.type === '核心問題')
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', fontSize: fontSize }}>
                <div className='text-white p-[16px]' style={{ fontSize: fontSize + 2 }}>核心問題 {props.index===0?'':'II'}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]'>
                    <div>{props.data?.mission?.pages?.[props.index]?.core_questions?.[0]?.question}</div>
                    <div className='text-[#9F0000]' style={{}}>學生答案結果</div>
                    <div className='flex flex-row flex-wrap gap-[8px]'>
                        {(showMore ? answers : answers?.slice(0, 10))?.map((answer, index) => (
                            <div key={index} className='p-[8px] rounded-[8px] bg-[#015B6B] text-white font-[400] px-[24px]'>
                                {answer?.answer}
                            </div>
                        ))}
                    </div>
                    <div className='flex flex-row justify-center mt-[12px]'>
                        <button onClick={handleShowMore} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white px-[4px] py-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                            <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                                {showMore ? '收起學生答案' : '更多學生答案'}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        )
    else if (props.type === '短答題') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div>{props.data?.question}</div>

                    <div className='text-[#9F0000]' style={{}}>學生答案結果</div>
                    <div className='flex flex-row flex-wrap gap-[8px]'>
                        {(showMore ? answers : answers?.slice(0, 10))?.map((answer, index) => (
                            <div key={index} className='p-[8px] rounded-[8px] bg-[#015B6B] text-white font-[400] px-[24px]'>
                                {answer?.answer}
                            </div>
                        ))}
                    </div>
                    <div className='flex flex-row justify-center mt-[12px]'>
                        <button onClick={handleShowMore} className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white px-[4px] py-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                            <div className='rounded-full px-[16px] py-[4px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                                {showMore ? '收起學生答案' : '更多學生答案'}
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-1') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：2.2 生成推斷；3.2 反思內容與形式）</p>
                        <p><br />有人說：「士可殺，不可辱」。意思是有氣節的人寧死也不受屈辱。<br /><br />司馬遷受宮刑後，選擇忍辱活下來，完成《史記》。你覺得這樣做算不算有氣節？</p>
                        {['算', '不算', '另有看法']?.map((option, idx) => (
                            <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[16px] flex flex-row items-center noto-san-hk'>
                                    <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }} >
                                        {/*  <div className='w-full h-full bg-[#005B8C] rounded-full' /> */}
                                    </button>
                                    <span className='font-[400] flex-1'>{option}</span>
                                </div>
                            </div>
                        ))}
                        {true && (
                            <>
                                <div className='text-[black] mt-[8px]'>另有看法：</div>
                                <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                            </>
                        )}
                        <div className='text-[black]'>（1）我認為「氣節」是指：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                        <div className='text-[black]'>（2）司馬遷選擇活下來，是因為：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                        <div className='text-[black]'>（3）請引用篇章中的一句話支持你的看法：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                        <p className='text-[#9F0000]'>學生言之成理，言之有據即可。</p>
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-2') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：2.2 生成推斷；2.3 整合文本內信息；3.2 反思內容與形式）</p>
                        <p><br />魯迅借《離騷》這首抒寫理想與憂憤的長詩，來形容《史記》這種散文體中的深厚感情。結合課文《廉頗藺相如列傳》與篇章二，說明人物的言行或遭遇怎樣打動你。</p>
                        {['藺相如', '廉頗']?.map((option, idx) => (
                            <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[16px] flex flex-row items-center noto-san-hk'>
                                    <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }}>
                                        {'藺相如' === option && <div className='w-full h-full bg-[#005B8C] rounded-full' />}
                                    </button>
                                    <span className='font-[400] flex-1'>{option}</span>
                                </div>
                            </div>
                        ))}
                        <div className='w-full rounded-[12px] p-[16px] text-white font-bold mt-[8px]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                            【思考提示】人物所盼望的，與實際發生的事情有甚麼距離？作者寫下的哪個動作、比喻或結果，使這份心情更具體？
                        </div>
                        <div className='text-[black] mt-[8px]'>原文片段｜概括/說明 </div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000] min-h-[150px]' value='【參考答案／建議】選藺相如，可指出藺相如面對強秦的威逼與殺身之禍，毫不退縮；選廉頗，可據「被甲上馬，以示尚可用」與「遂不召」指出願望及結果的落差。感受與文學評價可有不同。' />
                        <div className='text-[black]'>人物想做甚麼？遇到甚麼難處？</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' />
                        <div className='text-[black]'>這個片段最打動我的地方是</div>
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-3') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：2.4 整合跨文本信息；3.3 發現並處理衝突）</p>
                        <p><br />司馬遷說自己忍辱，是因為《史記》處於草創階段，還未能成書；廉頗晚年「被甲上馬」是想證明自己「尚可用」，盼望再為趙國效力。兩人各有想繼續完成的事情。<br /><br />【單選題】 魯迅認為，要把作者的身世與筆下人物聯繫閱讀。那閱讀司馬遷的《史記》，是應該：</p>
                        {[
                            '甲　分別理解司馬遷的生平事跡和他筆下的廉頗的故事，因為兩人身分與處境不同。',
                            '乙　結合起來閱讀，看到兩人都在困境中牽掛尚未實現的志願。合讀有助我們理解司馬遷的堅持，也體會廉頗失意的分量。',
                            '丙　只理解廉頗的故事。因司馬遷寫廉頗晚年，只為補充趙國史事，這段文字與人的情感無關。'
                        ]?.map((option, idx) => (
                            <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[16px] flex flex-row items-center noto-san-hk'>
                                    <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }} >
                                        {'乙　結合起來閱讀，看到兩人都在困境中牽掛尚未實現的志願。合讀有助我們理解司馬遷的堅持，也體會廉頗失意的分量。' === option && <div className='w-full h-full bg-[#005B8C] rounded-full' />}
                                    </button>
                                    <span className='font-[400] flex-1'>{option}</span>
                                </div>
                            </div>
                        ))}
                        <p className='text-[#9F0000]'>【參考答案／建議】選乙。甲以身分差異排除比較；丙忽略文章中的願望與情感。乙能把兩人的未竟志願相聯，同時保留處境差異。</p>
                        <div className='w-full mt-[8px]' style={{}}>
                            {/* 【選擇＋說明】我選____。 */}
                            從兩篇各找一處支持這個判斷的字句，說清兩人的「想完成」各指甚麼。
                        </div>
                        {/* <div className='text-[black] mt-[8px]'>篇章一：司馬遷｜概括/說明原文</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value='【參考答案／建議】司馬遷：「草創未就」、「惜其不成」，牽掛尚未完成的著述；'/>
                        <div className='text-[black]'>他牽掛的是：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' />
                        <div className='text-[black]'>篇章二：廉頗｜概括/說明原文</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value='【參考答案／建議】廉頗：「以示尚可用」，盼望再次為趙國效力。' />
                        <div className='text-[black]'>他牽掛的是：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' /> */}
                        <div className='w-full'>
                            <table className='w-full'>
                                <tr className='w-full'>
                                    <th className='p-[8px] w-[20%]'></th>
                                    <th className='p-[8px] w-[40%] text-left h-full'>篇章一：司馬遷</th>
                                    <th className='p-[8px] w-[40%] text-left h-full'>篇章二：廉頗</th>
                                </tr>
                                <tr className='w-full'>
                                    <td className='p-[8px] w-[20%]'>概括/說明原文</td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'「草創未就」、「惜其不成」'} readOnly />
                                    </td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'「以示尚可用」'} readOnly />
                                    </td>
                                </tr>
                                <tr className='w-full'>
                                    <td className='p-[8px] w-[20%]'>他牽掛的是</td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'牽掛尚未完成的著述'} readOnly />
                                    </td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'盼望再次為趙國效力。'} readOnly />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className='text-[black]'>這兩處材料的共同點是</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value='【參考答案／建議】共同遭遇與魯迅評語可支持「相互參照」的讀法；本單元材料未提供司馬遷直接說「寫廉頗就是寫自己」的自述。可調整「證明」「一定」的語氣。' />
                        <div className='w-full mt-[8px]' style={{}}>
                            【評價解讀】有人進一步說：「這就證明司馬遷寫廉頗時，一定是在寫自己。」你會如何修正這句評價，使它更貼近實際情況？
                        </div>
                        <br />
                        <div className='text-[black]'>我的評價與修正</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' />

                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-4') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：2.2 生成推斷；2.4 整合跨文本信息；3.2 反思內容與形式）</p>
                        <p><br />整合看待司馬遷、藺相如、廉頗三人的事跡，人在艱難時刻，怎樣守住自己重視的事情？我們又可以如何理解司馬遷寫《史記》的信念？<br /><br />填寫下表：</p>
                        <div className='w-full'>
                            <table className='w-full'>
                                <tr className='w-full'>
                                    <th className='p-[8px] w-[20%]'></th>
                                    <th className='p-[8px] w-[40%] text-left h-full'>他面對甚麼難處？作了甚麼選擇？</th>
                                    <th className='p-[8px] w-[40%] text-left h-full'>這個選擇想守住甚麼？</th>
                                </tr>
                                <tr className='w-full'>
                                    <td className='p-[8px] w-[20%]'>司馬遷<br />（篇章一）</td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'受刑受辱'} readOnly />
                                    </td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'完成《史記》'} readOnly />
                                    </td>
                                </tr>
                                <tr className='w-full'>
                                    <td className='p-[8px] w-[20%]'>廉頗<br />（篇章二）</td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'年老被棄，不受信任'} readOnly />
                                    </td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'再次為趙國效力'} readOnly />
                                    </td>
                                </tr>
                                <tr className='w-full'>
                                    <td className='p-[8px] w-[20%]'>藺相如<br />（篇章二）</td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'面對強秦，可能被殺'} readOnly />
                                    </td>
                                    <td className='p-[8px] w-[40%] text-left border-[1px] border-[#ccc]'>
                                        <textarea className='w-full h-full p-[8px] text-[#9F0000]' value={'趙國尊嚴與安全'} readOnly />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-5') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：1.1 獲取並提取文本內信息；2.3 整合文本內信息；3.1 評估質量與真實性；3.3 發現並處理衝突）</p>
                        <div className='flex flex-col bg-[#E2F4F6] rounded-[12px] overflow-hidden' style={{ border: '1px solid #D1E3EA' }}>
                            <div className='flex flex-row items-center w-full p-[16px] justify-start bg-[#123F50] font-bold text-white' style={{ fontSize: fontSize + 4 }}>
                                <img src='/secondary/tasks/史筆千秋/v1.png' alt='' className='w-[20px] h-[20px] mr-[8px]' />
                                讀史討論區
                            </div>
                            <div className='w-full p-[16px] text-[#6D828D] bg-white' style={{ fontSize: fontSize - 2 }}>全部留言 · 5 則評論</div>
                            <div className='w-full p-[16px] flex flex-col gap-[16px]' style={{ fontSize }}>
                                {[
                                    { icon: '甲', name: '@看結果', text: '荊軻是一個失敗的刺客。連任務都沒有完成，他的故事有甚麼值得反覆閱讀的？' },
                                    { icon: '乙', name: '@路過看史', text: '荊軻是衛國人，燕國和他沒關係。他去刺秦，根本是沒事找事、湊熱鬧。' },
                                    { icon: '丙', name: '@看準備', text: '荊軻憑一時血氣答應刺秦，事前連安排也沒有。' },
                                    { icon: '丁', name: '@問動機', text: '荊軻到了失敗時才說想活捉秦王，這個說法只是替自己開脫。' },
                                    { icon: '戊', name: '@讀寫法', text: '我記住荊軻，是因為他的歌聲、笑與斥罵都寫得鮮明。行動失敗，仍可留下值得細讀的人物形象。' }
                                ]?.map((item, index) =>
                                    <div key={index} className='flex flex-col p-[16px] w-full bg-white gap-[16px]' style={{ border: '1px solid #D1E3EA', borderRadius: '16px' }}>
                                        <div className='flex flex-row items-center gap-[8px]'>
                                            <div className='font-bold text-[#008D98] w-[44px] h-[44px] flex items-center justify-center rounded-full bg-[#E2F4F6] p-[8px]' style={{ fontSize: fontSize + 4 }}>
                                                {item.icon}
                                            </div>
                                            <div className='flex flex-col'>
                                                <div className='text-[black] font-bold' style={{ fontSize: fontSize + 2 }}>
                                                    {item.name}
                                                </div>
                                                <div className='text-[#6D828D]' style={{ fontSize: fontSize - 2 }}>
                                                    評論 {item.icon}
                                                </div>
                                            </div>
                                            <div className='flex-1 flex flex-row justify-end items-center h-full'>
                                                <img src='/secondary/tasks/史筆千秋/more.png' alt='' className='w-[30px] object-contain' />
                                            </div>
                                        </div>
                                        <p>{item.text}</p>
                                        <div className='bg-[#D1E3EA] h-[1px] w-full' />
                                        <div className='w-full flex flex-row justify-start items-center' style={{}}>
                                            <img src='/secondary/tasks/史筆千秋/v2.png' alt='' className='w-[240px] object-contain' />
                                        </div>
                                    </div>)}
                            </div>
                            <div className='w-full p-[16px] text-[#6D828D] bg-white'>
                                <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} >選擇評論與回覆</button>
                            </div>
                        </div>
                        <p>
                            這些評論有根據嗎？<br /><br />選一則評論，從本文找出能檢驗它的原文。指出對方哪一句有根據、哪一步推論有問題，再提出你的回應。
                        </p>
                        {[
                            '甲　@看結果',
                            '乙　@路過看史',
                            '丙　@看準備',
                            '丁　@問動機',
                            '戊　@讀寫法'
                        ]?.map((option, idx) => (
                            <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[16px] flex flex-row items-center noto-san-hk'>
                                    <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }} >
                                        {/* {interactionAnswer1 === option && <div className='w-full h-full bg-[#005B8C] rounded-full' />} */}
                                    </button>
                                    <span className='font-[400] flex-1'>{option}</span>
                                </div>
                            </div>
                        ))}
                        <div className='text-[black] mt-[8px]'>我想回應：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        <div className='text-[black]'>這句話：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        <div className='text-[black]'>原文「……」顯示：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        <div className='text-[black]'>因此我認為：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        <div className='bg-[#D1E3EA] h-[1px] w-full' />
                        <div className='w-full flex flex-row justify-start items-center' style={{}}>
                            <img src='/secondary/tasks/史筆千秋/v3.png' alt='' className='w-[240px] object-contain' />
                        </div>
                        <p className='text-[#9F0000]'>
                            【參考答案／建議】<br />
                            甲：原文「事不就」確指行動失敗。但失敗是否等於沒有價值？可看太史公的評語。<br />
                            乙：「善待之」、「固請」、「然後許諾」可核對荊軻在燕國的交往與受託。他與燕國有無關係？<br />
                            丙：「久之」、「有所待」、「為治行」可核對他的考慮與準備。他是否「憑一時血氣」？<br />
                            丁：「誠得劫秦王」是太子丹最初的計劃。荊軻的說法與此是否一致？<br />
                            戊：易水送別的歌聲、殿階前的笑、事敗後的斥罵，都是原文具體描寫的內容。
                        </p>
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-6') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：3.1 評估質量與真實性；3.2 反思內容與形式；3.3 發現並處理衝突）</p><br />
                        <p className='text-[#003A57]' style={{ fontSize: fontSize - 4 }}>能力點｜3.1 評估質量與真實性；3.2 反思內容與形式；3.3 發現並處理衝突<br /><br /></p>
                        <p>讀帖子 → 選立場 → 查原文 → 發表回覆<br /><br />以下帖子呈現不同的讀史觀點。請閱讀各帖，選擇立場加入討論。</p>
                        <div className='flex flex-col bg-[#E2F4F6] rounded-[12px] overflow-hidden' style={{ border: '1px solid #D1E3EA' }}>
                            <div className='flex flex-row items-center w-full p-[16px] justify-start bg-[#123F50] font-bold text-white' style={{ fontSize: fontSize + 4 }}>
                                <img src='/secondary/tasks/史筆千秋/v1.png' alt='' className='w-[20px] h-[20px] mr-[8px]' />
                                讀史討論區
                            </div>
                            <div className='w-full p-[16px] flex flex-col gap-[16px]' style={{ fontSize }}>
                                {[
                                    { icon: '主', name: '@讀史隨筆', subtext: '主帖 · 發起討論', text: '司馬遷是不是春秋筆法抬高了項羽，貶低了劉邦，導致我們現在一直敬仰項羽，罵劉邦小人？就像霸王別姬這件事，司馬遷怎麼知道的？還有劉邦不顧老爹，讓項羽殺了分碗肉吃。逃跑時為了減輕馬車負載，一腳踢下兒女，這些事司馬遷是不是亂寫的？' },
                                    { icon: '1', name: '@另一種讀法', subtext: '回覆 1 · 回應主帖', text: '我覺得不能這樣看。司馬遷寫項羽，也沒有隱瞞他的缺點。篇末評語說他「自矜功伐，奮其私智而不師古」，這是很嚴厲的批評。而且項羽的各種暴行，史記寫了一大堆，史記中項羽的惡行比劉邦多十倍都不止。如果真是偏愛，為甚麼要寫他剛愎自用、放走劉邦、最終失敗？' },
                                    { icon: '2', name: '@第三種聲音', subtext: '回覆 2 · 回應主帖', text: '我看過這樣的評論：問題不在「偏愛誰」，而在司馬遷寫人的方式。他寫劉邦的缺點，也寫劉邦的優點；寫項羽也是一樣。劉邦的正面形象主要集中在知人善用，負面形象主要集中在「江湖氣」以及數次狼狽逃跑。項羽的正面形象主要集中在作戰英勇，以及他非常具有視覺效果的人生結局，負面形象主要集中在殘暴、情緒化。' },
                                    { icon: '3', name: '@史學愛好者', subtext: '回覆 3 · 回應主帖', text: '補充一點：劉邦踹孩子這件事，司馬遷是寫在〈樊酈滕灌列傳〉裏，不是寫在〈高祖本紀〉裏。《漢書》才把它寫進〈高帝紀〉。而且司馬遷寫劉邦是「龍種」，寫他斬白蛇，搞得跟真命天子一樣。他對劉邦胸襟、眼界、格局、政治頭腦方面的肯定也是相當多的。' },
                                    { icon: '4', name: '@司馬遷研究者', subtext: '回覆 4 · 回應主帖', text: '還有一個關鍵：項羽為甚麼能進入「本紀」？司馬遷的標準是「王迹所興」——曾經實際主宰過天下興亡的人，才有資格寫入本紀。秦亡之後、漢興之前，項羽才是華夏大地上真正的主宰者。他沒有稱帝，是因為他本身出身六國貴族，是分封秩序的堅定維護者，不在乎「皇帝」的名號，而不是沒有實力稱帝。所以把項羽列入本紀，是依照標準，不是偏愛。' }
                                ]?.map((item, index) =>
                                    <div key={index} className='flex flex-col p-[16px] w-full bg-white gap-[16px]' style={{ border: '1px solid #D1E3EA', borderRadius: '16px' }}>
                                        <div className='flex flex-row items-center gap-[8px]'>
                                            <div className='font-bold text-[#008D98] w-[44px] h-[44px] flex items-center justify-center rounded-full bg-[#E2F4F6] p-[8px]' style={{ fontSize: fontSize + 4 }}>
                                                {item.icon}
                                            </div>
                                            <div className='flex flex-col'>
                                                <div className='text-[black] font-bold' style={{ fontSize: fontSize + 2 }}>
                                                    {item.name}
                                                </div>
                                                <div className='text-[#6D828D]' style={{ fontSize: fontSize - 2 }}>
                                                    {item.subtext}
                                                </div>
                                            </div>
                                            <div className='flex-1 flex flex-row justify-end items-center h-full'>
                                                <img src='/secondary/tasks/史筆千秋/more.png' alt='' className='w-[30px] object-contain' />
                                            </div>
                                        </div>
                                        <p>{item.text}</p>
                                        <div className='bg-[#D1E3EA] h-[1px] w-full' />
                                        <div className='w-full flex flex-row justify-start items-center' style={{}}>
                                            <img src='/secondary/tasks/史筆千秋/v2.png' alt='' className='w-[240px] object-contain' />
                                        </div>
                                    </div>)}
                            </div>
                            <div className='w-full p-[16px] text-[#6D828D] bg-white gap-[16px] flex flex-row'>
                                <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} >選擇評論與回覆</button>
                                <button className='text-white px-[36px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} >查閱補充原文</button>
                            </div>
                        </div>
                        <div className='w-full rounded-[12px] p-[16px] text-white font-bold mt-[8px] flex flex-col' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                            詞語提示｜春秋筆法<br /><br />
                            以簡約的字句寄寓褒貶，是「春秋筆法」的常見含義。論壇把這個詞用於討論作者的態度<br /><br />
                            <u className='font-[400]'><a href='https://dict.revised.moe.edu.tw/dictView.jsp?ID=126202' target='_blank' rel='noopener noreferrer'>教育部《重編國語辭典修訂本》「春秋筆法」</a></u>
                        </div>
                        <b className='text-[#178E95] mt-[16px]' style={{ fontSize: fontSize + 4 }}>(1)【點選】你較認同哪一個立場？</b>
                        <p className='text-[#178E95]'>（能力點：3.1 評估質量與真實性；3.2 反思內容與形式）</p><br />
                        <p className='my-[8px]'>可先選一個立場，再在回覆中說明你同意哪些內容、哪些說法仍須補充。</p>
                        {[
                            '@讀史隨筆：司馬遷春秋筆法抬高了項羽，貶低了劉邦。',
                            '@另一種讀法：司馬遷沒有偏愛，他對項羽也有嚴厲批評。',
                            '@第三種聲音：問題不在偏愛誰，而在讀者只撿一邊的材料來對比。',
                            '@史學愛好者：還應考慮劉邦的正面描寫及記事所在的篇章。',
                            '@司馬遷研究者：項羽入本紀是依照標準，不是偏愛。',
                            '我部分認同，或有其他看法：'
                        ]?.map((option, idx) => (
                            <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[16px] flex flex-row items-center noto-san-hk'>
                                    <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }}  >
                                        {/* {interactionAnswer1 === option && <div className='w-full h-full bg-[#005B8C] rounded-full' />} */}
                                    </button>
                                    <span className='font-[400] flex-1'>{option}</span>
                                </div>
                            </div>
                        ))}
                        <div className='text-[black] mt-[8px]'>其他看法：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        <b className='text-[#178E95] mt-[16px]' style={{ fontSize: fontSize + 4 }}>(2) 用一處原文支持你的判斷。</b>
                        <p className='my-[8px]'>從篇章二選一處原文，結合本篇的「補充選讀」。說明它支持帖子中的哪一點，或使哪一點需要修正。</p>
                        <div className='w-full p-[16px] text-[#6D828D] bg-white gap-[6px] flex flex-row font-bold flex-wrap'>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }}>甲 棄子</button>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }}>乙 分羹</button>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }}>丙 用人</button>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }}>丁 本紀</button>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }}>戊 暴行</button>
                        </div>
                        <p className='text-[#178E95]'>溫馨提示：點擊按鈕，閱讀補充內容選讀</p>
                        <div className='text-[black]'>我概括/說明的證據：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000] min-h-[140px]' value={'【參考答案／建議】棄子也見於〈項羽本紀〉，可核對記事位置；「吾能用之」是劉邦自己的說法；「政由羽出」說明項羽曾掌政令。這些材料可檢驗帖子的具體陳述，作者整體好惡仍須綜合判斷。'} />
                        <div className='text-[black]'>我的說明：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value={''} />
                        <b className='text-[#178E95] mt-[16px]' style={{ fontSize: fontSize + 4 }}>（3）【回覆】選一位網民，回應他的說法。</b>
                        <p className='my-[8px]'>回覆中引用篇章二的原文，並解釋原文與判斷的關係。</p>
                        {[
                            '@讀史隨筆',
                            '@另一種讀法',
                            '@第三種聲音',
                            '@史學愛好者',
                            '@司馬遷研究者',
                        ]?.map((option, idx) => (
                            <div key={idx} className='w-full rounded-full bg-[white]' style={{ boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
                                <div className='px-[16px] py-[8px] min-w-[140px] rounded-[8px] checkbox-main gap-[16px] flex flex-row items-center noto-san-hk'>
                                    <button style={{ width: 25, height: 25, borderRadius: '99px', border: '2px solid #005B8C', }}  >
                                        {/* {interactionAnswer5 === option && <div className='w-full h-full bg-[#005B8C] rounded-full' />} */}
                                    </button>
                                    <span className='font-[400] flex-1'>{option}</span>
                                </div>
                            </div>
                        ))}
                        <div className='text-[black]'>我的回覆：</div>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        <div className='bg-[#D1E3EA] h-[1px] w-full' />
                        <div className='w-full flex flex-row justify-start items-center' style={{}}>
                            <img src='/secondary/tasks/史筆千秋/v3.png' alt='' className='w-[240px] object-contain' />
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3-7') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>
                        <p className='text-[#178E95]'>（能力點：1.1 獲取並提取文本內信息；2.2 生成推斷；2.4 整合跨文本信息；3.2 反思內容與形式）</p><br />
                        <p>把篇章一的易水送別與篇章二的垓下惜別放在一起讀。下面摘出兩段關鍵字句；需要時可回看前後文。</p>
                        <div className='flex flex-row items-stretch mt-[8px] select-text'>
                            <div className='flex-1 p-[12px] text-white font-bold flex flex-col' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                                甲　荊軻：易水送別
                            </div>
                            <div className='flex-1 p-[12px] text-white font-bold flex flex-col' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)', borderLeft: '1px solid #ffffff' }}>
                                乙　項羽：垓下惜別
                            </div>
                        </div>
                        <div className='flex flex-row items-stretch select-text'>
                            <div className='flex-1 p-[12px] text-black flex flex-col' style={{}}>
                                <i>「風蕭蕭兮易水寒，壯士一去兮不復還！」復為羽聲慨，士皆瞋目，髮盡上指冠。於是荊軻就車而去，終已不顧。</i>
                            </div>
                            <div className='flex-1 p-[12px] text-black flex flex-col' style={{ borderLeft: '1px solid #ffffff' }}>
                                <i>「力拔山兮氣蓋世，時不利兮騅不逝。騅不逝兮可奈何，虞兮虞兮奈若何！」歌數闋，美人和之。項王泣數行下，左右皆泣，莫能仰視。</i>
                            </div>
                        </div>
                        <p>甲的前文還寫「士皆垂淚涕泣」。兩段語譯分見篇章一、二。</p>
                        <div className='w-full p-[16px] text-[#6D828D] bg-white gap-[6px] flex flex-row font-bold flex-wrap'>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }} >篇章一：易水送別</button>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }} >篇章二：垓下</button>
                            <button className='text-white px-[16px] py-[4px] rounded-[8px]' style={{ background: 'linear-gradient(to right, #178E95, #142939)' }} onClick={() => { }} >篇章二：鉅鹿</button>
                        </div>
                        <b className='text-[#178E95] mt-[16px]' style={{ fontSize: fontSize + 4 }}>(1)【概括/說明 ＋填表】相近的描寫，寫出怎樣的分別？</b>
                        <p className='my-[8px]'>從兩段各選一處歌辭、動作或旁人反應，放回人物當時的處境，說明你讀到的心情。</p>
                        <div className='flex flex-col gap-[8px] bg-[#D9D9D9] rounded-[8px] p-[16px]'>
                            <div className='text-[black]'>荊軻<br /><br />人物與原文字句｜概括/說明</div>
                            <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value={'【參考答案／建議】篇章一：荊軻即將赴秦，歌辭預示一去難返，送行者由涕泣轉為激昂；'} />
                            <div className='text-[black]'>他此時面對甚麼？</div>
                            <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                            <div className='text-[black]'>這處描寫讓你感到甚麼？</div>
                            <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        </div>
                        <div className='flex flex-col gap-[8px] bg-[#D9D9D9] rounded-[8px] p-[16px]'>
                            <div className='text-[black]'>項羽<br /><br />人物與原文字句｜概括/說明 </div>
                            <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value={'【參考答案／建議】篇章二：項羽被圍，歌辭向虞美人發問，左右隨之落淚。感受可異，但須與處境及字句相連。'} />
                            <div className='text-[black]'>他此時面對甚麼？</div>
                            <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                            <div className='text-[black]'>這處描寫讓你感到甚麼？</div>
                            <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                        </div>
                        <b className='text-[#178E95] mt-[16px]' style={{ fontSize: fontSize + 4 }}>(2)【連讀前文】項羽的往事，怎樣加深眼前的感受？</b>
                        <p className='text-[#178E95]'>（能力點：2.3 整合文本內信息；3.2 反思內容與形式）</p><br />
                        <p className='my-[8px]'>篇章二較早寫諸侯「膝行而前，莫敢仰視」，垓下則寫「左右皆泣，莫能仰視」。讀過鉅鹿的威勢，再讀垓下的歌與淚，你對項羽有甚麼更深的理解？請連繫兩處文字說明。<br /><br />我的理解：</p>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc] text-[#9F0000]' value={'【參考答案／建議】「莫敢仰視」寫諸侯因威勢而低首；「莫能仰視」寫左右同悲。相近字句形成前後照應，鉅鹿的盛勢為垓下的敗別增加落差。'} />
                        <b className='text-[#178E95] mt-[16px]' style={{ fontSize: fontSize + 4 }}>(3)【跨篇評析】只有「悲歌和眼淚」，就足以解釋感動嗎？</b>
                        <p className='my-[8px]'>有人說：「兩個人物都很悲壯，所以讀者會感動。」你會怎樣把這個評語說得更具體？用兩篇各一處原文，解釋字句及前後經歷如何使人物各具性情、牽動讀者。可沿用上表的材料。<br /><br />我的跨篇評析：</p>
                        <textarea className='w-full p-[8px] rounded-[8px] border-[1px] border-[#ccc]' value={''} />
                    </div>
                </div>
            </div>
        )
    } else if (props.type === '互動題3') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <RenderAQuestion 
                    question={props.data}
                />
            </div>
        )
    } else if (props.type === '互動題4') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <RenderAQuestion 
                    question={props.data}
                />
            </div>
        )
    } else if (props.type === '互動題2') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <RenderAQuestion 
                    question={props.data}
                />
            </div>
        )
    } else if (props.type === '互動題') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <RenderAQuestion 
                    question={props.data}
                />
            </div>
        )
    } else if (props.type === '儒家知識卡') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                <RenderAQuestion 
                    question={props.data}
                />
            </div>
        )
    } else if (props.type === '座標題1') {
        return (
            <div className='font-[900] text-[#34778C] flex flex-col w-full gap-[4px] rounded-[8px] bg-[#F0FBFF]' style={{ background: 'white' }}>
                <div className='px-[16px] py-[8px]' style={{ fontSize: fontSize + 2 }}>探究 {props.questionIndex}</div>
                {/* <div className='text-black w-full rounded-[8px] bg-[white] p-[16px] flex flex-col gap-[8px]' style={{ background: "linear-gradient(to top, #fff, #F0FBFF)" }}>
                    <div className='rounded-[8px] flex flex-col gap-[8px] w-full font-[400] pb-[16px]'>
                        <b>{props.data?.question}</b>

                    </div>
                </div> */}
                <RenderAQuestion 
                    question={props.data}
                />
            </div>
        )
    }

    return null
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(InteractiveAreaAnswer)
